<template><!-- 更新モーダル -->
<transition name="modal">
  <div class="modal-mask" @click="$emit('close')">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div>
        <CRow>
        <CCol>
          <table class="table">
            <thead>
              <a style="font-size: 20px"><strong>更新内容確認</strong></a>
              <CCardText><strong>以下の内容で更新してよろしいですか？</strong></CCardText>
            </thead>
            <tbody>
              <tr>
                <td>
                  <a><strong>社員番号</strong></a><br>
                  {{ employee }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>氏名</strong></a><br>
                  {{ user }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>電話番号</strong></a><br>
                  {{ tel }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>住所</strong></a><br>
                  {{ live }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>E-Mail</strong></a><br>
                  {{ mail }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>ユーザ種別</strong></a><br>
                  {{ select }}
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>承認者権限</strong></a><br>
                  <block v-if="approver_flg === true">有</block>
                  <block v-else>無</block>
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>有給日数</strong></a><br>
                  {{ paid }}<block v-if="paid">日</block><block v-else></block>
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>代休日数</strong></a><br>
                  {{ comp }}<block v-if="comp">日</block><block v-else></block>
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>固定内残業</strong></a><br>
                  {{ fixed_over_time }}<block v-if="fixed_over_time"></block><block v-else></block>
                </td>
              </tr>
              <tr>
                <td>
                  <a><strong>Slack ID</strong></a><br>
                  {{ slack_id }}
                </td>
              </tr>
            </tbody>
          </table>
        </CCol>
        </CRow>
        <CRow>
          <CCol>
            <button @click="$emit('close')" class="btn btn-secondary">キャンセル</button>
          </CCol>
          <CCol>
            <save-button
              :label="'更新'"
              :loading="loading"
              @click="$emit('update')"
              class="btn btn-primary"
            />
          </CCol>
        </CRow>
        </div>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
import SaveButton from '../common/SaveButton';
export default {
  components: { SaveButton },
  name: 'UpdateModal',
  data () {
    return {
    }
  },
  props: {
    employee: String,
    user: String,
    tel: String,
    live: String,
    mail: String,
    pass: String,
    select: String,
    approver_flg: Boolean,
    paid: Number,
    comp: Number,
    fixed_over_time: String,
    slack_id: String,
    loading: Boolean
  }
}
</script>

<style scoped>
  .modal-mask {
      position: fixed;
      z-index: 9998;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(80, 80, 80, 0.5);
      display: table;
      transition: opacity .3s ease;
    }
    .modal-wrapper {
      display: table-cell;
      vertical-align: middle;
    }
    .modal-container {
      width: 40%;
      margin: 0px auto;
      padding: 20px 30px;
      background-color: #fff;
      border-radius: 2px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
      transition: all .3s ease;
      font-family: Helvetica, Arial, sans-serif;
    }
</style>
